import * as types from './mutation-types'
import * as api from '@/api/chat'
// import txim from './im-cube'
import IM from './im-proxy'
import VueCookies from 'vue-cookies'
VueCookies.config('90d')
import { getVisitorCubeId } from '@/api/login/index'
import { Message } from 'element-ui'
// import defaultHeadImg from '@/assets/images/lenovo-service2.png'
import cloudDefaultImage from '@/assets/images/cloudDefaultImage.png'
import { getQueryString } from '@/utils'
import {
  convertSplitMessage,
  convertToMessage,
  convertToEngineerTmpMessage
} from '@/store/modules/call-center/convert'
const MESSAGE_TYPE = {
  Text: 'Text',
  Image: 'Image',
  Voice: 'Voice',
  Video: 'Video',
  File: 'File'
}
const SEND_TYPE = {
  Image: 'PicUrl',
  Text: 'Content',
  Video: 'MediaUrl',
  File: 'File'
}
function removeToken() {
  VueCookies.remove('Sign')
  VueCookies.remove('cube_uid')
  VueCookies.remove('token')
  Message({
    type: 'error',
    message: '网络有点小问题...,请刷新'
  })
  window.location.reload()
}
// let _qiniuToken
/**
 * 获取唯一ID
 * @param prefix
 * @return {string}
 */
export function uuid(prefix = 'id') {
  return `${prefix}_${Math.random()
    .toString(36)
    .substr(2)}`
}
// 游客登录
export const visitorLogin = ({ commit }, data = 1) => {
  const para = {
    phone: getQueryString('phone') || '',
    email: getQueryString('email') || '',
    sign: getQueryString('sign') || ''
  }
  return getVisitorCubeId(para.phone ? para : { sign: getQueryString('sign') || '' })
    .then(res => {
      return new Promise(resolve => {
        sessionStorage.setItem('cube_uid', res.data.cube_uid)
        sessionStorage.setItem('token', res.data.token)
        sessionStorage.setItem('cube_uid', res.data.cube_uid)
        sessionStorage.setItem('token', res.data.token)
        resolve({
          cube_uid: res.data.cube_uid,
          token: res.data.token
        })
      })
    })
    .catch(() => {
      Message({
        type: 'error',
        message: '网络有点小问题...,请刷新'
      })
    })
  // if (sessionStorage.getItem('token')) {
  //   if (data === 3 || data.type === 3) return
  //   return new Promise(resolve => {
  //     resolve({
  //       cube_uid: sessionStorage.getItem('cube_uid'),
  //       token: sessionStorage.getItem('token')
  //     })
  //   })
  // } else {
  //   return getVisitorCubeId(sessionStorage.getItem('token'))
  //     .then(res => {
  //       return new Promise(resolve => {
  //         sessionStorage.setItem('cube_uid', res.data.cube_uid)
  //         sessionStorage.setItem('token', res.data.token)
  //         resolve({
  //           cube_uid: res.data.cube_uid,
  //           token: res.data.token
  //         })
  //       })
  //     })
  //     .catch(() => {
  //       Message({
  //         type: 'error',
  //         message: '网络有点小问题...,请刷新'
  //       })
  //     })
  // }
}
/**
 * 初始化IM 工具
 * @param commit
 * @param rootState
 * @return {PromiseLike<T | never> | Promise<T | never> | *}
 */
export const initIM = ({ commit, rootGetters, rootState }) => {
  if (sessionStorage.getItem('token')) {
    return api.getSign(sessionStorage.getItem('token')).then(response => {
      if (response.data) {
        VueCookies.set('Sign', response.data)
        commit(types.SET_IS_LONGIN, true)
        commit(types.SET_LOGIN_SIG, response.data)
        return IM.getInstance(
          sessionStorage.getItem('cube_uid'),
          response.data,
          rootState.call.userInfo,
          rootState.call.creactsessionPara.engineer_code,
          sessionStorage.getItem('token')
        )
      }
    }).catch((err) => {
      if (err === '身份不合法') {
        removeToken()
      }
    })
  } else {
    return visitorLogin({
      commit,
      rootGetters,
      rootState
    }).then(res => {
      return api.getSign(sessionStorage.getItem('token')).then(response => {
        if (response.data) {
          VueCookies.set('Sign', response.data)
          commit(types.SET_LOGIN_SIG, response.data)
          return IM.getInstance(
            sessionStorage.getItem('cube_uid'),
            response.data,
            rootState.call.userInfo,
            rootState.call.creactsessionPara.engineer_code,
            rootState.call.loginInfo.token
          )
        }
      }).catch((err) => {
        if (err === '身份不合法') {
          removeToken()
        }
      })
    })
  }
}
// 获取用户信息
export const getUserInfo = ({ commit, rootState }) => {
  return api.getUserInfo(sessionStorage.getItem('token')).then(res => {
    if (res.data) {
      const userInfo = {
        ...(rootState.call.userInfo || {})
      }
      if (res.data.name || res.data.nickname) {
        userInfo.user_name = res.data.nickname || res.data.name
      }
      if (res.data.headimgurl) {
        // userInfo.avatar = res.data.headimgurl
      }
      if (res.data.phone) {
        // userInfo.avatar = res.data.headimgurl
      }
      console.log(userInfo, 'res.userInfo')
      commit(types.SET_USER_INFO, userInfo)
    }
  })
}
// im登录状态
export const isLoginIm = ({ commit }) => {
  commit(types.SET_IMLOGIN, true)
}
export const clearImLogin = ({ commit }) => {
  commit(types.SET_IMLOGIN, false)
}
// 机器人会话清除通话时间
export const romoveTime = ({ commit }) => {
  commit(types.SET_START_TIME, '')
  commit(types.SET_SESSION_ID, '')
}
// 推送话术
export const autoSendMsg = (
  { commit, rootGetters, rootState },
  { messages }
) => {
  const message = convertToMessage(messages, rootState.call.userInfo)
  commit(types.USER_SEND_MESSAGE, message)
}
/**
 * 初始化一个会话
 */
export const initWebChat = ({ commit, rootGetters, rootState }, data) => {
  const para = {
    token: sessionStorage.getItem('token'),
    queue_code: data.skill,
    pathway: data.channel || 'webchat'
  }
  const defaultPara = {
    token: sessionStorage.getItem('token'),
    channel: data.channel || 'webchat'
  }
  const userPara = {
    mark_id: data.productID,
    cube_uid: sessionStorage.getItem('cube_uid')
  }
  if (Number(data.type) === 1) {
    // 机器人
    api.startRobot(defaultPara).then(res => {
    })
  }
  if (Number(data.type) === 2) {
    // 默认队列
    api.closeRobot(defaultPara)
    setTimeout(() => {
      api.toBigQueue(para).then(r => {
        // todo 这里加商品信息传递接口
        if (userPara.mark_id) {
          api.getProductRelation(userPara)
        }
        if (r.message.info !== 'Success') {
          Message({
            type: 'warning',
            message: r.message.info
          })
        }
      })
    }, 500)
  }
  if (Number(data.type) === 3) {
    // 点选
    const params = {
      token: sessionStorage.getItem('token'),
      queue_code: data.skill,
      pathway: data.channel,
      engineer_code: data.engineer_code
    }
    api.closeRobot(defaultPara)
    setTimeout(() => {
      api.selectPersonal(params).then(res => {
        // todo 这里加商品信息传递接口
        if (userPara.mark_id) {
          api.getProductRelation(userPara)
        }
        if (res.message.info !== 'Success') {
          Message({
            type: 'warning',
            message: res.message.info
          })
        }
        if (res.statusCode + '' === '422') {
          api.startRobot(defaultPara).then(res => {
          })
        }
      })
    }, 500)
  }
}
/**
 * 获得一个消息处理函数
 * @param commit
 * @param rootrootState
 * @param rootGetters
 * @param rootState
 * @param dispatch
 * @return {Function}
 */
export const messageHandle = (
  { commit, rootGetters, rootState },
  { message, data }
) => {
  // 存储工程师信息
  let engineerInfo
  if (message.MessageBody.engineer_code) {
    engineerInfo = {
      engineer_code:
        message.MessageBody.engineer_code || getQueryString('engineer_code'),
      engineer_img: message.MessageBody.avgineer_avatar,
      engineer_name: message.MessageBody.engineer_name
    }
    commit(types.SET_ENGINEER_INFO, engineerInfo)
    if (message.MessageBody.ClientType === 'engineer') {
      commit(types.SET_START_TIME, message.MessageBody.SendTime)
      commit(types.SET_SESSION_ID, message.MessageBody.SessionID)
      commit(types.IS_ENGNINEER, true, { root: true })
    }
  } else {
    if (message.MessageBody.message_from) {
      commit(types.SET_START_TIME, '')
      commit(types.IS_ENGNINEER, false, { root: true })
      commit(types.SET_ENGINEER_INFO, {
        engineer_code: '',
        engineer_img: '',
        engineer_name: ''
      })
    }
  }

  message = convertToMessage(
    message,
    rootState.call.userInfo,
    rootGetters.engineerInfo
  )
  commit(types.USER_SEND_MESSAGE, message)
}
// 关闭会话
export const closeSession = ({ commit, rootGetters, rootState }, sessionId) => {
  return api
    .closeSession({ sessionId, token: sessionStorage.getItem('token') })
    .then(res => {
      commit(types.SET_SESSION_ID, sessionId)
    })
}
// 获取历史会话列表
export const getHistoryList = ({ commit, rootState, rootGetters }, code) => {
  api.getHistoryList(sessionStorage.getItem('token')).then(res => {
    if (res.statusCode === 200) {
      const sessionItem = res.data.map(item => {
        return {
          id: item.id,
          engineer: {
            engineer_code: item.engineer_code,
            engineer_img: item.engineer_avatar,
            engineer_name: item.engineer_name
          }
        }
      })
      if (sessionItem.length) {
        const engineerInfo = {
          engineer_code: sessionItem[0].engineer
            ? sessionItem[0].engineer.engineer_code
            : null,
          engineer_img: sessionItem[0].engineer
            ? sessionItem[0].engineer.engineer_img
            : null,
          engineer_name: sessionItem[0].engineer
            ? sessionItem[0].engineer.engineer_name
            : null
        }
        commit(types.SET_SESSION_ITEM, sessionItem)
        commit(types.SET_ENGINEER_INFO, code === '5' ? engineerInfo : {})
        commit(types.SET_SESSION_ID, '')
        commit(types.SET_SESSION_ID, sessionItem[0].id)
        getHistoryMsg(
          {
            commit,
            rootState,
            rootGetters
          },
          {
            session: sessionItem[0],
            user_name: rootGetters.userInfo.user_name,
            token: sessionStorage.getItem('token'),
            code,
            isFirstLoad: true
          }
        )
      }
    }
  })
}
// 获取历史会话消息
export const getHistoryMsg = (
  { commit, rootState, rootGetters },
  { session, user_name, token, code, isFirstLoad }
) => {
  return api.getHistoryMsg(session.id, token).then(res => {
    if (res.statusCode === 200) {
      const history = []
      const data = res.data.data
      let engineer = ''
      rootState.call.historyMsgList.map((item, ind) => {
        if (session.id === item.id) {
          engineer = item.engineer
        }
      })
      data.map((item, ind) => {
        history.push({
          client_type: item.client_type,
          authorName:
            item.client_type !== 'user' ? engineer.engineer_name : user_name,
          engineer_code:
            item.client_type !== 'user' ? engineer.engineer_code : '',
          avatar:
            item.client_type !== 'user'
              ? engineer.engineer_img || cloudDefaultImage
              : rootGetters.userInfo.avatar,
          content: item,
          emotion: item.emotion,
          media_url: item.media_url,
          id: uuid('m'),
          isEngineer: item.client_type !== 'user',
          robotIndex: -1,
          sendTime: item.send_time,
          // showTime: setTime(item.send_time),
          sessionId: session.id,
          timestamp: Date.parse(item.send_time),
          type: item.message_type
        })
      })
      history.map((item, index) => {
        // 过滤文本为空的数据
        if (item.type === 'Text') {
          item.content = item.content.text
          if (item.content === '') {
            history.splice(index, 1)
          }
        } else if (item.type === 'File') {
          const content = item.content
          item.content = {
            name: content.file_name,
            size: content.file_size,
            media: content.file_type,
            url: content.media_url
          }
        }
      })
      if (
        history.length &&
        history[history.length - 1].sessionId === rootGetters.sessionId &&
        code === '5'
      ) {
        commit(types.SET_START_TIME, history[history.length - 1].sendTime)
      }
      // 加载更多历史消息
      if (isFirstLoad) {
        history.unshift(convertSplitMessage('— — — — 历史消息 — — — —'))
        setTimeout(() => {
          const ul = document.getElementsByClassName('chat-content')[0]
          ul.scrollTop = ul.scrollHeight + 200
        }, 0)
      }
      commit(types.UPDATE_USER_SEND_MESSAGE, history)
    }
    return history.length
  })
}
// 发送文本消息
export const sendMessage = (
  { commit, rootState, rootGetters },
  { text, userInfo }
) => {
  const tmpMessage = convertToEngineerTmpMessage(
    text,
    MESSAGE_TYPE.Text,
    userInfo,
    rootGetters.engineerInfo,
    rootGetters.sessionId
  )
  const messageBody = {
    message_body: {
      accesses_id: getQueryString('accesses_id'),
      Skill: getQueryString('Skill') || getQueryString('skill') || '',
      MsgType: MESSAGE_TYPE.Text.toLowerCase(),
      [SEND_TYPE[MESSAGE_TYPE.Text]]: text,
      CreateTime: Date.parse(new Date()) / 1000
    },
    token: sessionStorage.getItem('token')
  }
  var promise = new Promise((resolve, reject) => {
    api
      .postMessageBody(messageBody)
      .then(data => {
        if (data.statusCode === 200) {
          tmpMessage.error = ''
          resolve({
            code: data.statusCode
          })
        } else {
          reject({
            code: data.statusCode
          })
        }
      })
      .catch(() => {
        tmpMessage.error = 'error'
      })
  })
  promise.then(
    data => {
      // do something when success
      if (data.code === 200) {
        tmpMessage.error = ''
      } else {
        tmpMessage.error = 'error'
      }
    },
    error => {
      tmpMessage.error = 'error'
      if (error.code === '10999') {
        // 身份不合法
        console.log(error)
      }
    }
  )
  commit(types.USER_SEND_MESSAGE, tmpMessage)
}
// 发送图片消息
export const sendImage = (
  { commit, rootState, rootGetters },
  { base64, userInfo }
) => {
  const tmpMessage = convertToEngineerTmpMessage(
    base64,
    MESSAGE_TYPE.Image,
    userInfo,
    rootGetters.engineerInfo,
    rootGetters.sessionId
  )
  // 发起http请求,发送图片
  const _http = blob => {
    // commit(types.USER_SEND_MESSAGE, data.response.data.data.image_url)
    return api
      .uploadFileImage(blob, sessionStorage.getItem('token'))
      .then(data => {
        if (data.response.data.image_url) {
          tmpMessage.PicUrl = data.response.data.image_url
          const messageBody = {
            message_body: {
              accesses_id: getQueryString('accesses_id'),
              Skill: getQueryString('Skill') || getQueryString('skill') || '',
              MsgType: MESSAGE_TYPE.Image.toLowerCase(),
              [SEND_TYPE[MESSAGE_TYPE.Image]]: data.response.data.image_url,
              CreateTime: Date.parse(new Date()) / 1000
            },
            token: sessionStorage.getItem('token')
          }
          var promise = new Promise((resolve, reject) => {
            api
              .postMessageBody(messageBody)
              .then(data => {
                if (data.statusCode === 200) {
                  tmpMessage.error = ''
                  resolve({
                    code: data.statusCode
                  })
                } else {
                  tmpMessage.error = 'error'
                  reject({
                    code: data.statusCode
                  })
                }
              })
              .catch(() => {
                tmpMessage.error = 'error'
              })
          })
          promise.then(
            data => {
              // do something when success
              if (data.code) {
                tmpMessage.error = ''
              }
            },
            error => {
              tmpMessage.error = 'error'
              console.log(error)
              // Message({
              //   type: 'error',
              //   message: '当前网络中断，请检查网络环境，并重新进入会话'
              // })
              // do something when failure
            }
          )
        }
      })
      .catch(() => {
        tmpMessage.error = 'error'
        // Message({
        //   type: 'error',
        //   message: '当前网络中断，请检查网络环境，并重新进入会话'
        // })
      })
  }
  commit(types.USER_SEND_MESSAGE, tmpMessage)
  // http://devdocs.io/dom/fetch_api/using_fetch
  // base64 to blob
  // 兼容不支持fetch的移动端浏览器
  return new Promise((resovle, reject) => {
    try {
      var meta = base64.split(',')
      var mime = meta[0].match(/:(.*?);/)[1]
      var bytes = window.atob(base64.split(',')[1])
      var ab = new ArrayBuffer(bytes.length)
      var ia = new Uint8Array(ab)
      for (var i = 0; i < bytes.length; i++) {
        ia[i] = bytes.charCodeAt(i)
      }
      const blob = new Blob([ab], { type: mime })
      resovle(blob)
    } catch (err) {
      reject(err)
    }
  })
    .then(_http)
    .catch(err => {
      console.log('网络出错', err)
    })
}

/**
 * 工程师发送文件消息
 * @param commit
 * @param rootGetters
 * @param file
 * @param session
 * @returns {Promise}
 */
export const sendFile = (
  { commit, rootGetters },
  { file, progress, userInfo }
) => {
  if (!file.gid) {
    file.gid = `progress_${new Date().valueOf()}`
  }
  const fileInfo = {
    gid: file.gid,
    name: file.name,
    media: file.name.substring(file.name.lastIndexOf('.') + 1),
    url: '',
    file
  }

  if (
    [
      'jpg',
      'gif',
      'png',
      'doc',
      'docx',
      'xls',
      'xlsx',
      'ppt',
      'pptx',
      'pdf',
      'txt',
      'zip',
      'rar',
      'mp4',
      'rm',
      'avi',
      'mov'
    ].indexOf(fileInfo.media) < 0
  ) {
    return Promise.reject(
      '请选择符合下列文件格式的文件上传：doc,docx,xls,xlsx,ppt,pptx,pdf,txt,zip,rar,mp4,rm,avi,mov'
    )
  }

  const size = file.size
  let unitSize = '0'
  if (size > 1024) {
    if (size > 1024 * 1024) {
      unitSize = Math.floor((size / 1024 / 1024) * 100) / 100 + 'MB'
    } else {
      unitSize = Math.floor((size / 1024) * 100) / 100 + 'KB'
    }
  } else {
    unitSize = size + 'B'
  }
  fileInfo.size = unitSize
  const tmpMessage = convertToEngineerTmpMessage(
    fileInfo,
    MESSAGE_TYPE.File,
    userInfo
  )
  commit(types.USER_SEND_MESSAGE, tmpMessage)
  const curryFn = gid => {
    return percent => {
      progress(percent, fileInfo.gid)
    }
  }
  const token = sessionStorage.getItem('token')
  return new Promise((resolve, reject) => {
    api
      .uploadFile(file, curryFn(fileInfo.gid))
      .then(res => {
        const data = res.data
        if (res.statusCode === 200) {
          const content = tmpMessage.content
          content.url = data.url
          const messageBody = {
            message_body: {
              accesses_id: getQueryString('accesses_id'),
              Skill: getQueryString('Skill') || getQueryString('skill') || '',
              MsgType: MESSAGE_TYPE.File.toLowerCase(),
              [SEND_TYPE[MESSAGE_TYPE.File]]: content.url,
              CreateTime: Date.parse(new Date()) / 1000,
              FileName: content.name,
              MediaUrl: content.url,
              FileType: content.media,
              FileSize: content.size
            },
            token
          }
          api
            .postMessageBody(messageBody)
            .then(data => {
              if (data.statusCode === 200) {
                tmpMessage.error = ''
                resolve({
                  code: data.statusCode
                })
              } else {
                tmpMessage.error = 'error'
                reject({
                  code: data.statusCode
                })
              }
            })
            .catch(err => {
              console.error('send file error：', err)
              tmpMessage.error = 'error'
            })
        } else {
          return reject(res.data)
        }
      })
      .catch(err => {
        reject(err)
      })
  })
}

export const clearMessage = ({ commit }) => {
  commit(types.CLEAR_USER_SEND_MESSAGE)
}
/**
 * 用户发送的图片加载错误调用方法
 * @param commit
 * @param message
 * @param session
 */
export const customerImageLoadSuccess = ({ commit }, { message }) => {
  commit(types.UPDATE_MESSAGE_STATE_SUCCESS, {
    sessionId: message.sessionId,
    message
  })
}
export const setScreenWidth = ({ commit }, { screen, width }) => {
  commit(types.SET_SCREEN_TYPE, {
    screen,
    width
  })
}

/**
 * 用户发送的图片加载错误调用方法
 * @param commit
 * @param message
 * @param session
 */
export const reloadCustomerImage = ({ commit }, { message }) => {
  commit(types.RELOAD_CUSTOMER_IMAGE, message)
}
/**
 * 从聊天记录列表中删除消息,通常用于发送失败的图片重发时使用
 * @param commit
 * @param id
 * @param session
 */
export const deleteMessageFromList = ({ commit }, { id }) => {
  commit(types.DELETE_MESSAGE_FROM_LIST, {
    id
  })
}



// WEBPACK FOOTER //
// ./src/store/modules/call-center/new-actions.js